import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { productionApi } from './production-api'

export function useProductionCapabilities() {
  const { user } = useAuth()
  return useQuery({
    queryKey: ['production', user?.tenant_id, user?.id, 'capabilities'],
    queryFn: productionApi.capabilities,
    enabled: !!user,
    retry: false,
    staleTime: 30_000,
  })
}
